import CONSTANTS from '../constants'
import { postRequest } from '../../services'
import { APICONFIG } from '../apiConfig'
import { addEventLog } from './EventsLog'

// Calls the API to fetch Ticket Details
export const getQrTicketDetails = (payload) => (dispatch) => {
    let payloadTicket = { ...payload, 'device_type': 'web' }
    dispatch(addEventLog(payloadTicket, CONSTANTS.GET_TICKET_DETAILS_REQUEST))
    dispatch({ type: CONSTANTS.GET_TICKET_DETAILS_REQUEST })
    return postRequest(APICONFIG.getSearchTicketUrl, payload).then((res) => {
        let resObject = { ...payloadTicket, ...res }
        dispatch(addEventLog(resObject, CONSTANTS.GET_TICKET_DETAILS_SUCCESS))
        dispatch({ type: CONSTANTS.GET_TICKET_DETAILS_SUCCESS, data: res })
        return res
    }).catch((err) => {
        let errObject = { ...payloadTicket, ...err }
        dispatch(addEventLog(errObject, CONSTANTS.GET_TICKET_DETAILS_FAILURE))
        dispatch({ type: CONSTANTS.GET_TICKET_DETAILS_FAILURE, errorMessage: err?.errors?.message })
        return err
    })
}

export const ticketValidation = (payload) => dispatch => {
    let payloadTicket = { ...payload, 'device_type': 'web' }
    dispatch(addEventLog(payloadTicket, CONSTANTS.TICKET_VALIDATE_REQUEST))
    dispatch({ type: CONSTANTS.TICKET_VALIDATE_REQUEST })
    return postRequest(APICONFIG.ticketValidateUrl, payloadTicket).then((res) => {
        let resObject = { ...payloadTicket, ...res }
        dispatch(addEventLog(resObject, CONSTANTS.TICKET_VALIDATE_SUCCESS))
        dispatch({ type: CONSTANTS.TICKET_VALIDATE_SUCCESS, data: res })
        return res
    }).catch((err) => {
        let errObject = { ...payloadTicket, ...err }
        dispatch(addEventLog(errObject, CONSTANTS.TICKET_VALIDATE_FAILED))
        dispatch({ type: CONSTANTS.TICKET_VALIDATE_FAILED, errorMessage: err?.errors?.message })
        return err
    })
}
